import { TabPanel } from '@reach/tabs';
import { FC } from 'react';

export interface TabProps {
  title: string;
}

export const Tab: FC<TabProps> = ({ children }) => {
  return <TabPanel>{children}</TabPanel>;
};
